import { ETargetPage, MainFiltersWidget } from '@cian/valuation-main-filters-widget';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { ValuationFiltersDesktop } from '../../components/ValuationFilters';
import { selectIsWebview } from '../../selectors/page';
import { ValuationSubmitDesktopContainer } from '../ValuationSubmitContainer';

interface IValuationFiltersDesktopContainer {
  buttonRef: React.Ref<HTMLDivElement>;
  containerRef: React.Ref<HTMLDivElement>;
}

export function ValuationFiltersDesktopContainer({ buttonRef, containerRef }: IValuationFiltersDesktopContainer) {
  const isWebview = useSelector(selectIsWebview);

  return (
    <ValuationFiltersDesktop
      containerRef={containerRef}
      buttonRef={buttonRef}
      mainFiltersWidget={<MainFiltersWidget isWebview={isWebview} targetPage={ETargetPage.valuation} />}
      valuationFiltersSubmit={<ValuationSubmitDesktopContainer />}
    />
  );
}
